import { RecordContent, RecordViewMode } from '@aipb/gulliver/dynamic-gallery/model';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { IAlbum } from 'ngx-lightbox/lightbox-event.service';
import { NgxMasonryOptions } from 'ngx-masonry/lib/ngx-masonry-options';

function createCaption(record: RecordContent): string {
  if (record.label && !record.sublabel) {
    return record.label;
  }

  if (!record.label && record.sublabel) {
    return record.sublabel;
  }

  return `${record.label} - ${record.sublabel}`;
}

@Component({
  selector: 'dg-record-masonry',
  templateUrl: './record-masonry.component.html',
  styleUrls: ['./record-masonry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordMasonryComponent {
  @Input() viewMode: RecordViewMode;
  masonryOptions: NgxMasonryOptions = {
    itemSelector: '.masonry-item',
    columnWidth: '.grid-sizer',
    horizontalOrder: true,
    percentPosition: true
  };

  constructor(private _lightbox: Lightbox) {}

  private _imageItems: IAlbum[] = [];

  get imageItems() {
    return this._imageItems;
  }

  private _items: RecordContent[] = [];

  @Input() set items(value: RecordContent[]) {
    this._items = value;

    this._imageItems = value.map((record) => {
      const thumb = record.images3if ? record.images3if[0] + 'full/,350/0/default.jpg' : record.images[0].thumb;

      return {
        src: record.images[0].main,
        caption: createCaption(record),
        thumb: thumb,
        downloadUrl: record.images[0].main
      };
    });
  }

  onOpen(index: number) {
    this._lightbox.open(this._imageItems, index, {
      enableTransition: false,
      centerVertically: true
    });
  }

  isMasonry() {
    return this.viewMode === 'masonry';
  }

  isMasonryWithLabel() {
    return this.viewMode === 'masonry-with-label';
  }
}
